<template>
  <!-- A moving strip of words or logos (mo-marquee); it stops for reduced
       motion, and the server shows it still. Logos are pictures with names. -->
  <section class="s2-marquee t-band" :data-variant="variant" :data-background="section.background || null" :aria-label="label">
    <div class="mo-marquee" :data-kind="kind">
      <ul class="mo-marquee__track">
        <li v-for="(it, i) in items" :key="i" class="s2-marquee__item">
          <img v-if="kind === 'logos' && it.src" :src="it.src" :alt="it.text || ''" loading="lazy" class="s2-marquee__logo" />
          <span v-else>{{ it.text }}</span>
          <span v-if="kind === 'words'" class="s2-marquee__sep" aria-hidden="true">✳</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
import {computed} from "vue";
import {mediaOf} from "@/utils/blocks.js";

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const kind = computed(() => (props.section.layout === "logos" ? "logos" : "words"));
const items = computed(() => (Array.isArray(props.section.items) ? props.section.items : typeof props.section.items === "string" ? props.section.items.split("\n") : []).map((it) => {
  if (typeof it === "string") return {text: it.trim(), src: ""};
  const m = mediaOf(it?.image || it);
  return {text: it?.text || it?.label || it?.title || "", src: m.kind === "image" ? m.src : ""};
}).filter((it) => it.text || it.src).slice(0, 20));
const label = computed(() => items.value.map((it) => it.text).filter(Boolean).join(", ") || "Logos");
</script>

<style scoped>
.s2-marquee { padding: clamp(1rem, 2.5vw, 1.75rem) 0; overflow: hidden; }
.mo-marquee__track { list-style: none; margin: 0; padding: 0; display: flex; gap: 2.5rem; align-items: center; width: max-content; }
.s2-marquee__item { display: flex; align-items: center; gap: 2.5rem; white-space: nowrap; font-family: var(--t-font-display); font-size: clamp(1.4rem, 3vw, 2.3rem); text-transform: var(--t-display-case, none); }
.s2-marquee__sep { color: var(--t-accent); font-size: .8em; }
.s2-marquee__logo { height: 44px; width: auto; filter: grayscale(1); opacity: .8; }
</style>
